import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './components/atoms/Login';
import Pages from './Pages/index';
import ForgotPassword from './components/atoms/ForgotPassword';
import Layout from './components/Layout';
import AgentDetail from './components/atoms/AgentDetail';
import VerifyOtp from './Pages/verify-otp';
import { Suspense } from 'react';
import Loaders from './components/atoms/Loaders';
import CreateCompaign from './components/atoms/CreateCompaign';
import ChangePassword from './components/atoms/ForgotPassword/ChangePassword';
import Successful from './components/atoms/ForgotPassword/Successful';
import OtpConfirm from './components/atoms/ForgotPassword/OtpConfirm';
import DeleteDomain from './components/atoms/DeleteDomain';
import TasksPreviewSection from './components/atoms/TasksPreviewSection';
import DeleteDomainEmail from './components/atoms/DeleteDomainEmail';
import AddNewMember from './components/atoms/MyTeam/AddNewMember';
import DeleteMember from './components/atoms/MyTeam/DeleteMember';
import CampaignLaunched from './components/atoms/CreateCompaign/CampaignLaunched';
import Signup from './components/atoms/SignUp';
import FindLeads from './components/atoms/FindLeads';
import OnBoarding from './components/atoms/Onboarding';
import Billing from './components/atoms/Billing';
import DeleteCampaign from './components/atoms/CompaignDetail/DeleteCampaign';
import RouteGuard from './components/RouteGuard';
import AddMoreLeads from './components/atoms/CompaignDetail/AddMoreLeads';
import UnsubscribeCampaign from './Pages/unsubscribe-campaign';
import DeleteTask from './components/atoms/Tasks/DeleteTask';
import LeadPreview from './Pages/lead-preview';
import SingleListLead from './Pages/single-list-lead';
import SingleImportJob from './Pages/single-job-lead';
import AcceptWorkspaceInvitePage from './Pages/accept-workspace-invite';
import FlowBuilder from './components/automation/FlowBuilder';
import QuickAction from './Pages/quick-action';
import BulkCsvUpload from './components/atoms/BulkCsvUpload';
import ConnectEmailModal from './components/atoms/ConnectEmailDomainModal/ConnectEmailModal';
import NewOnboarding from './components/atoms/NewOnboarding';
import CreateOffer from './Pages/create-offer';
import OfferDetail from './Pages/offer-detail';

const Router = () => {
  return (
    <Routes>
      {/* Public Routes - No authentication required */}
      <Route
        path="/"
        element={
          <RouteGuard requireAuth={false}>
            <Login />
          </RouteGuard>
        }
      />

      <Route
        path="/sign-up"
        element={
          <RouteGuard requireAuth={false}>
            <Signup />
          </RouteGuard>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <RouteGuard requireAuth={false}>
            <ForgotPassword />
          </RouteGuard>
        }
      />

      <Route
        path="/verify-otp"
        element={
          <RouteGuard requireAuth={false}>
            <VerifyOtp />
          </RouteGuard>
        }
      />

      <Route
        path="/unsubscribe-campaign/:id"
        element={
          <RouteGuard requireAuth={false}>
            <UnsubscribeCampaign />
          </RouteGuard>
        }
      />

      <Route
        path="/accept-workspace-invite"
        element={
          <RouteGuard requireAuth={false}>
            <AcceptWorkspaceInvitePage />
          </RouteGuard>
        }
      />

      <Route
        path="/onboarding"
        element={
          <RouteGuard requireAuth={true}>
            <OnBoarding />
          </RouteGuard>
        }
      />

      <Route
        path="/billing"
        element={
          <RouteGuard requireAuth={true}>
            <Billing />
          </RouteGuard>
        }
      />

      <Route
        path="/verify-email"
        element={
          <RouteGuard requireAuth={false}>
            <OtpConfirm />
          </RouteGuard>
        }
      />

      <Route
        path="/change-password"
        element={
          <RouteGuard requireAuth={false}>
            <ChangePassword />
          </RouteGuard>
        }
      />

      <Route
        path="/successful"
        element={
          <RouteGuard requireAuth={true}>
            <Successful />
          </RouteGuard>
        }
      />

      {/* Automation Routes - Must be before /:view to prevent matching */}
      <Route
        path="/automation/flow-builder"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <FlowBuilder />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />


      {/* CSV Bulk Upload — restricted to ghous@webevis.cm inside component */}
      <Route
        path="/csv-upload"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <BulkCsvUpload />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      {/* Protected Routes - Authentication required */}
      <Route
        path="/:view"
        element={
          <RouteGuard requireAuth={true}>
            <Pages />
          </RouteGuard>
        }
      />

      <Route
        path="/dashboard/agents/:id"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <AgentDetail />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/lead-preview/:id"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <LeadPreview />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/single-list-lead/:id"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <SingleListLead />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/single-job-lead/:id"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <SingleImportJob />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/tasks-preview"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <TasksPreviewSection />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/find-leads"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <FindLeads />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/delete-task"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <DeleteTask />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/delete-domain"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <DeleteDomain />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/delete-email"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <DeleteDomainEmail />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/get-started"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <QuickAction />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />
      <Route
        path="/ai-onboarding"
        element={
          <RouteGuard requireAuth={true} skipStatusChecks>
            <Layout showTemplate={false}>
              <Suspense fallback={<Loaders viewLoader />}>
                <NewOnboarding />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/create-campaign"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <CreateCompaign />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/create-offer"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <CreateOffer />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/offers/:id"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <OfferDetail />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/connect-email-account"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={false}>
              <Suspense fallback={<Loaders viewLoader />}>
                <ConnectEmailModal />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/add-more-campaign"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <AddMoreLeads />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/delete-campaign"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <DeleteCampaign />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/campaign-launched"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <CampaignLaunched />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/add-new-member"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <AddNewMember />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      <Route
        path="/delete-member"
        element={
          <RouteGuard requireAuth={true}>
            <Layout showTemplate={true}>
              <Suspense fallback={<Loaders viewLoader />}>
                <DeleteMember />
              </Suspense>
            </Layout>
          </RouteGuard>
        }
      />

      {/* Catch all route - redirect to login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Router;
